import React from 'react'
import { EventDetails } from 'types/Event'
import { formatDateText } from 'utils/event'
import { getSeatLabelForSeatId } from 'utils/seatLabel'

import { SummaryColumn, SummaryContainer, SummaryRow, SummaryText, TicketPrice } from '../seatSelector.style'

interface SeatSummaryProps {
    currentEvent: EventDetails
    selectedSeats: string[]
    totalPrice: number
}

export const SeatSummary: React.FC<SeatSummaryProps> = ({ currentEvent, selectedSeats, totalPrice }) => {
    const normalSeats = currentEvent.location.auditorium.seats
    const gallerySeats = currentEvent.location.auditorium.gallery?.seats || []

    const formatSeatSelection = (seatIds: string[]) =>
        seatIds.map((seatId) => {
            // Find seat in either normal or gallery
            const seat = normalSeats.find((s) => s.seat_id === seatId) || gallerySeats.find((s) => s.seat_id === seatId)
            if (!seat) {
                return (
                    <SummaryRow key={seatId}>
                        <SummaryColumn>
                            <SummaryText>Invalid seat: {seatId}</SummaryText>
                        </SummaryColumn>
                        <TicketPrice>{`N/A`}</TicketPrice>
                    </SummaryRow>
                )
            }

            const label = getSeatLabelForSeatId(currentEvent, seatId) ?? 'Ismeretlen hely'

            const ticketInfo = currentEvent.tickets?.find((ticket) => ticket.seat_id === seatId)
            const ticketPrice = ticketInfo ? parseInt(ticketInfo.price.toString(), 10) : 0

            return (
                <SummaryRow key={seatId}>
                    <SummaryColumn>
                        <SummaryText>{formatDateText(currentEvent.event_date)}</SummaryText>
                        <SummaryText>{label ?? 'Ismeretlen hely'}</SummaryText>
                    </SummaryColumn>
                    <TicketPrice>{`${ticketPrice} Ft`}</TicketPrice>
                </SummaryRow>
            )
        })

    return (
        <SummaryContainer>
            <SummaryColumn>
                {formatSeatSelection(selectedSeats)}
                <hr style={{ border: '0.5px solid black', width: '100%' }} />
                <SummaryRow style={{ justifyContent: 'space-between' }}>
                    <p>Összesen:</p>
                    <TicketPrice>{`${totalPrice} Ft`}</TicketPrice>
                </SummaryRow>
            </SummaryColumn>
        </SummaryContainer>
    )
}
